import * as getters from './getters'
import * as actions from './actions'
import * as mutations from './mutations'

const state = {
  language: localStorage.getItem('manifestLang') || 'en',
  languages: [],
  loaded: false
}

const store = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}

export default store



// WEBPACK FOOTER //
// ./src/store/destiny/manifest/index.js